import * as Factory from 'factory.ts'
import faker from 'faker'

import { type ShippingAddress } from '../../models'

export const ShippingAddressMock = Factory.Sync.makeFactory<ShippingAddress>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.random.words(3)),
  addressLineOne: Factory.each(() => faker.address.streetAddress()),
  addressLineTwo: '',
  city: Factory.each(() => faker.address.city()),
  postalCode: Factory.each(() => faker.address.zipCode()),
  state_province: Factory.each(() => faker.address.state()),
  country: Factory.each(() => faker.address.country()),
})
